import React from 'react';

interface Props {
  title: string;
  summary?: string;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const SettingsSection: React.FC<Props> = ({ title, summary, open, onToggle, children }) => (
  <section className="intercom-settings-section">
    <button type="button" className="intercom-settings-section__toggle" onClick={onToggle} aria-expanded={open}>
      <span>
        <strong>{title}</strong>
        {summary && <small>{summary}</small>}
      </span>
      <span aria-hidden="true">{open ? '−' : '+'}</span>
    </button>
    {open && <div className="intercom-settings-section__body">{children}</div>}
  </section>
);
